// Port of api/fuel/app/classes/insights/ratings/types.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'

export default Segment.extend({
	name: 'types',
	insight: ['type'],
	run: function(type, owner, userIndex, detail, filter) {

		if (!owner.get_count_ratings()) return {}

		var types = []
		var threshold = (owner.get_threshold() * 2) + 1
		var typeFilter = (filter.type !== undefined) ? filter.type : 'category'
		var table = (typeFilter === 'category') ? 'category' : 'mechanic'
		var exclude = (typeFilter === 'category') ? [1042, 1044] : []
		var limit = detail ? 100 : 5
		var typeIndex = []
		var gameIndex = []
		var excludeSQL = exclude.length ? (' AND l.' + table + '_id NOT IN (' + Util.in(exclude) + ')') : ''

		var rankedTypes = Util.query(
			'SELECT l.' + table + '_id AS t,' +
			' group_concat(DISTINCT l.game_id) AS g,' +
			' COUNT(DISTINCT l.game_id) AS gc,' +
			' t.' + table + '_name AS n,' +
			' AVG(r.rating_value) AS r,' +
			' COUNT(DISTINCT r.rating_id) AS c' +
			' FROM game_' + table + ' l, ' + table + ' t, game g, rating r' +
			' WHERE t.' + table + '_id = l.' + table + '_id' +
			' AND g.game_id = l.game_id' +
			' AND g.game_type = 1' +
			' AND r.game_id = g.game_id' +
			' AND r.user_id IN (' + Util.in(userIndex) + ')' +
			excludeSQL +
			' GROUP BY l.' + table + '_id' +
			' HAVING COUNT(DISTINCT r.rating_id) >= ' + threshold +
			' ORDER BY AVG(r.rating_value) DESC, t.' + table + '_name ASC' +
			' LIMIT 0, ' + limit
		)

		for (var i = 0; i < rankedTypes.length; i++) {
			var rankedType = rankedTypes[i]
			typeIndex.push(parseInt(rankedType.t, 10))
			if (rankedType.g) {
				var ids = rankedType.g.split(',')
				for (var gi = 0; gi < ids.length; gi++) {
					if (ids[gi] !== '') gameIndex.push(ids[gi])
				}
			}
		}

		if (!typeIndex.length || !gameIndex.length) return { types: types }

		var typeGames = Util.query(
			'SELECT l.' + table + '_id AS t, l.game_id AS g, AVG(r.rating_value) AS r' +
			' FROM game_' + table + ' l, rating r' +
			' WHERE l.' + table + '_id IN (' + Util.in(typeIndex) + ')' +
			' AND r.game_id = l.game_id' +
			' AND l.game_id IN (' + Util.in(gameIndex) + ')' +
			' AND r.user_id IN (' + Util.in(userIndex) + ')' +
			' GROUP BY l.' + table + '_id, l.game_id' +
			' ORDER BY AVG(r.rating_value) DESC, l.game_id ASC',
			null,
			't',
			true
		)

		for (var j = 0; j < rankedTypes.length; j++) {
			var typeRow = rankedTypes[j]
			var ratings = []
			var games = (typeGames[typeRow.t] || []).slice(0, 3)

			for (var k = 0; k < games.length; k++) {
				var game = games[k]
				var gameId = parseInt(game.g, 10)
				ratings.push({
					id: gameId,
					rating: game.r ? parseFloat(game.r) : '-'
				})
				this._references.games.push(gameId)
			}

			types.push({
				id: parseInt(typeRow.t, 10),
				name: typeRow.n,
				count: parseInt(typeRow.c, 10),
				rating: Math.round(parseFloat(typeRow.r) * 10) / 10,
				games: ratings,
				gamesCount: parseInt(typeRow.gc, 10)
			})
		}

		return {
			types: types
		}

	}
})
